// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card---3wUK_"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/customer/CompanyCard/Card.styl
// module id = k36k
// module chunks = 89